import AxiosManager from "../_axiosManager";

export async function postRecommend(parkIds: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/recommend/park",
    {
      parkIds,
    },
  );

  return res;
}

export async function delRecommend(parkId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/recommend/park/${parkId}`,
  );

  return res;
}
